import React from "react";
import { graphql } from "gatsby";
import CountryTemplate from "@components/countryPage/countryTemplate";

const IndexPage = ({
  data: {
    prismic: { country },
  },
  pageContext,
}) => {
  if (!country) return null;

  return <CountryTemplate data={country} pageContext={pageContext} />;
};

export const query = graphql`
  query CountryByUidAndLang($lang: String!, $slug: String!) {
    prismic {
      country(lang: $lang, uid: $slug) {
        countryName
        countryImage
        countryCapitalCity
        countryCurrencyCode
        countryCurrencySymbol
        countryCallingCode
        countryFlag
        countryDescription
        countryFooter
        countryCities {
          countryCity {
            ... on PRISMIC_City {
              cityName
              cityImage
              cityDescription
              _meta {
                uid
              }
            }
          }
        }
      }
    }
  }
`;

export default IndexPage;
